<template>
  <div class="space-y-1">
    <div
      v-for="(color, idx) in localSeries"
      :key="idx"
      class="flex items-center gap-2"
    >
      <span class="text-xs text-gray-400 w-5 text-right shrink-0">{{ idx }}</span>
      <color-picker
        :pureColor="color"
        useType="pure"
        format="hex"
        lang="En"
        shape="circle"
        @update:pureColor="onColorUpdate(idx, $event)"
        @pureColorChange="onColorChange(idx, $event)"
      />
      <button
        class="ml-auto text-red-400 hover:text-red-300 text-xs px-1 py-0.5 rounded hover:bg-slate-600 transition-colors"
        @click="removeSeries(idx)"
        title="Remove series"
      >✕</button>
    </div>

    <button
      class="mt-1 text-cyan-300 hover:text-cyan-200 text-xs font-medium hover:bg-slate-600 px-2 py-1 rounded transition-colors"
      @click="addSeries"
    >+ Add series</button>
  </div>
</template>

<script>
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

const DEFAULT_COLORS = ['#ff4444', '#4488ff', '#44bb66', '#ffaa22', '#aa44ff', '#22ccdd'];

export default {
    name: 'ChartSeriesColors',
    components: { ColorPicker },

    props: {
        node: { type: Object, required: true },
    },

    computed: {
        localSeries() {
            return Array.isArray(this.node.series) ? this.node.series : [];
        },
    },

    methods: {
        onColorUpdate(idx, newColor) {
            const layer = this.node.getLayer?.();
            if (layer && !layer._historySuppress) {
                layer._beforeColors ??= {};
                layer._beforeColors[`series_${idx}`] ??= this.node.series?.[idx];
            }
            if (Array.isArray(this.node.series)) {
                this.node.series[idx] = newColor;
            }
            const chartSeries = this.node.hass_config?.chart_series;
            if (Array.isArray(chartSeries) && chartSeries[idx]) {
                chartSeries[idx].color = newColor;
            }
        },

        onColorChange(_idx, _evt) {
            this.node.adjust('series');
        },

        addSeries() {
            if (!Array.isArray(this.node.series)) this.node.series = [];
            const nextColor = DEFAULT_COLORS[this.node.series.length % DEFAULT_COLORS.length];
            this.node.series.push(nextColor);
            if (this.node.hass_config) {
                if (!Array.isArray(this.node.hass_config.chart_series)) {
                    this.node.hass_config.chart_series = [];
                }
                this.node.hass_config.chart_series.push({ entity: '', color: nextColor, history_hours: 1 });
            }
            this.node.adjust('series');
        },

        removeSeries(idx) {
            if (!Array.isArray(this.node.series)) return;
            this.node.series.splice(idx, 1);
            if (Array.isArray(this.node.hass_config?.chart_series)) {
                this.node.hass_config.chart_series.splice(idx, 1);
            }
            this.node.adjust('series');
        },
    },
};
</script>
